
<div :class="[multipage === true ? 'multi-page' : 'single-page', 'home-page']">
  <a-breadcrumb class="home-breadcrumb">
    <a-breadcrumb-item><router-link to="/home">主页</router-link></a-breadcrumb-item>
    <a-breadcrumb-item>系统主页</a-breadcrumb-item>
  </a-breadcrumb>
  <div class="not-menu-page home-content">
    <a-row :gutter="8" class="head-info">
      <a-card class="head-info-card">
        <a-col :xs="24" :lg="14" class="welcome-info">
          <div class="head-info-avatar">
            <img alt="头像" :src="avatar"
                 @error="$event.target.src.endsWith('/static/avatar/default.jpg') || ($event.target.src = 'static/avatar/default.jpg')" />
          </div>
          <div class="head-info-count">
            <div class="head-info-desc">
              <p>{{ user.deptName || '暂无部门' }} | {{ roleName }}</p>
            </div>
            <div class="head-info-time">
              上次登录时间：{{ user.lastLoginTime || '第一次访问系统' }}
            </div>
            <div class="head-info-welcome">{{ welcomeMessage }}</div>
          </div>
        </a-col>
        <a-col :xs="24" :lg="10" class="statistics-info">
          <a-row class="more-info">
            <a-col :span="8">
              <head-info title="今日IP" :content="todayIp" :center="false" :bordered="false" />
            </a-col>
            <a-col :span="8">
              <head-info title="今日访问" :content="todayVisitCount" :center="false" :bordered="false" />
            </a-col>
            <a-col :span="8">
              <head-info title="总访问量" :content="totalVisitCount" :center="false" />
            </a-col>
          </a-row>
        </a-col>
      </a-card>
    </a-row>
    <a-row :gutter="8" class="count-info">
      <a-col :span="24" class="visit-count-wrapper">
        <a-card title="近七日后台访问记录" class="visit-count">
          <a-spin :spinning="loading">
            <div class="visit-content">
              <div v-if="loadError" class="visit-error">
                <a-alert type="error" :message="loadError" show-icon />
                <a-button class="retry-button" @click="loadHomeData">重新加载</a-button>
              </div>
              <template v-else-if="!loading && series.length">
                <apexchart type="bar" height="300" :options="chartOptions" :series="series" />
                <div class="visit-detail">
                  <span v-if="isVisitEmpty">近七日暂无访问记录。</span>
                  鼠标悬浮在柱状图上，可查看当日“您”和“总数”的后台访问记录。
                </div>
              </template>
            </div>
          </a-spin>
        </a-card>
      </a-col>
    </a-row>
  </div>
</div>
